import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikProps } from "formik";
import { InquiryFilterDialogValues } from "src/models/Inquiry.model";
import InquiryFilterDialog from "./InquiryFilterDialog";
import {
  setDispositionOne,
  setDispositionTwo,
  setInquiryLabel,
  setLastFollowUpEndDate,
  setLastFollowUpStartDate,
  setNextFollowUpEndDate,
  setNextFollowUpStartDate,
  setDateFilter,
} from "src/redux/slices/InquirySlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";

type Props = {
  onClose: () => void;
};

const InquiryFilterDialogWrapper = ({ onClose }: Props) => {
  const dispatch = useDispatch();
  const { inquirylabel, dispositionOne, dispositionTwo , dateFilter , nextFollowupStartDate , nextFollowupEndDate , lastFollowupEndDate , lastFollowupStartDate } = useSelector(
    (state: RootState) => state.inquiry
  );

  // Form Initial Values
  const initialValues: InquiryFilterDialogValues = {
    startDate:dateFilter?.start_date || null ,
    endDate: dateFilter?.end_date || null,
    nextFollowupStartDate: nextFollowupStartDate || null ,
    nextFollowupEndDate:nextFollowupEndDate || null,
    lastFollowupStartDate: lastFollowupStartDate || null,
    lastFollowupEndDate: lastFollowupEndDate || null,
    inquirylabel: inquirylabel || null,
    dispositionOne: dispositionOne || null,
    dispositionTwo: dispositionTwo || null,
  };

  // Handle Submit
  const handleSubmit = (values: InquiryFilterDialogValues) => {
    dispatch(setInquiryLabel(values?.inquirylabel));
    dispatch(setDispositionOne(values?.dispositionOne));
    dispatch(setDispositionTwo(values?.dispositionTwo));
    dispatch(setNextFollowUpStartDate(values?.nextFollowupStartDate));
    dispatch(setNextFollowUpEndDate(values?.nextFollowupEndDate));
    dispatch(setLastFollowUpStartDate(values?.lastFollowupStartDate));
    dispatch(setLastFollowUpEndDate(values?.lastFollowupEndDate));
    dispatch(
      setDateFilter({
        start_date: values?.startDate,
        end_date: values?.endDate,
      })
    );

    onClose();
  };
  const handleReset = (formikProps: FormikProps<InquiryFilterDialogValues>) => {
    dispatch(setInquiryLabel(null));
    dispatch(setDispositionOne(null));
    dispatch(setDispositionTwo(null));
    dispatch(setNextFollowUpStartDate(null));
    dispatch(setNextFollowUpEndDate(null));
    dispatch(setLastFollowUpStartDate(null));
    dispatch(setLastFollowUpEndDate(null));
    dispatch(setDateFilter({
      start_date:null,
      end_date: null,
    }))
    formikProps?.resetForm();
  };

  return (
    <Dialog open maxWidth="md" fullWidth>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formikProps) => (
          <Form>
            <InquiryFilterDialog
              formikProps={formikProps}
              onClose={onClose}
              handleReset={() => handleReset(formikProps)}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default InquiryFilterDialogWrapper;
